import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import I18N from '../I18N';
const ErrorElement = () => (_jsxs("div", { "data-testid": "error-element", children: [_jsx("h1", { children: _jsx(I18N, { children: "errors.generic" }) }), _jsx(Link, { to: "/", children: _jsx(I18N, { children: "navigation.home" }) })] }));
export default ErrorElement;
